import { useAxios } from "@hooks"
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { useTranslation } from "react-i18next";

export const useEditQuestion = () => {

    const axios = useAxios();
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    const { message } = App.useApp();

    const mapQuestions = (categories: any) => {
        if (categories.length === 0) return [];
        if (categories[0]?.id !== undefined) return categories;
        return categories.map((category: any) => ({ id: category }));
    }

    const editQuestion = async (question: any) => {
        const questionData = {
            ...question,
            categories: mapQuestions(question.categories),
        }
        try {
            await axios.put(`/api/questions/${questionData.id}`, questionData);
        } catch (error) {
            throw new Error(t("messages.error.editQuestion"));
        }
    }

    return useMutation({
        mutationFn: editQuestion,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["questions"] });
            message.success(t("messages.success.editQuestion"));
        },
    });
}